export default "__VITE_ASSET__833c0884__"